<template>
  <v-row>
    <v-col cols="12">
      <search-card @clicked="(term) => getItems(term)" />
    </v-col>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="pagination.total"
        :loading="loading"
        class="elevation-1"
        hide-default-footer
      >
        <template v-slot:item.user_id="{ item }">
          <v-chip small outlined>
            {{ item.user.username }}
          </v-chip>
        </template>

        <template v-slot:item.prep_question_id="{ item }">
          <v-chip
            @click="
              $router.push({
                name: 'dashboard-prep-questions-create',
                params: { id: item.prep_question_id },
              })
            "
            small
            outlined
            color="primary"
            >{{ item.prep_question_id }}</v-chip
          >
        </template>

        <template v-slot:item.active="{ item }">
          <v-btn
            @click.stop="
              $store.dispatch('dashboard/prep/ReportsToggleActive', {
                item,
              })
            "
            icon
            :color="item.active ? 'green' : 'red'"
          >
            <v-icon>{{
              item.active ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline"
            }}</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            class="mx-1"
            small
            icon
            @click="
              $router.push({
                name: 'dashboard-prep-reports-get',
                params: { id: item.id },
                query: { parent_page: $route.query.page },
              })
            "
          >
            <v-icon>mdi-file</v-icon>
          </v-btn>
          <v-btn
            class="mx-1"
            small
            icon
            @click="
              $store
                .dispatch('dashboard/prep/ReportsRemove', {
                  item,
                })
                .then(() => {
                  items = items.filter((el) => {
                    return el.id != item.id;
                  });
                })
            "
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
    <v-col cols="12">
      <query-page-redirect :pagination="pagination" />
      <!-- <v-pagination
        v-model="pagination.page"
        :length="pagination.lastPage"
      ></v-pagination> -->
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import { axios } from "@/plugins/axios";
import SearchCard from "../../modules/SearchCard.vue";
import bus from "@/bus";
import QueryPageRedirect from "@/components/QueryPageRedirect";
export default {
  name: "dashboard-prep-reports",
  components: {
    SearchCard,
    QueryPageRedirect,
  },
  data() {
    return {
      items: [],
      options: {},
      loading: false,
      where: "",
      headers: [
        { text: "Active", value: "active", sortable: true },
        { text: "User", value: "user_id", sortable: true },
        { text: "Question", value: "prep_question_id", sortable: true },
        { text: "Date", value: "created_at", sortable: true },
        { text: "Actions", value: "actions", sortable: false },
      ],
      pagination: {
        lastPage: null,
        page: 1,
        perPage: null,
        total: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      auth: "auth/auth",
    }),
  },
  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
    "pagination.page"(page) {
      if (page > 0) {
        //this.getItems();
      }
    },
  },
  methods: {
    getItems(term = "") {
      this.where = term;
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const ascDesc = sortDesc && sortDesc[0] ? "desc" : "asc";

      return axios
        .get(`/prep/reports`, {
          params: {
            page: this.pagination.page,
            perPage: this.pagination.perPage,
            orderby:
              sortBy && sortBy.length > 0 ? `${sortBy[0]}|${ascDesc}` : ``,
            where: this.where,
          },
        })
        .then((response) => {
          this.pagination = {
            lastPage: response.data.lastPage,
            page: response.data.page,
            perPage: response.data.perPage,
            total: response.data.total,
          };
          this.items = response.data.data;
          return Promise.resolve(response.data);
        })
        .catch((error) => {
          return Promise.reject(error.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    // this.getItems();
  },
  updated() {
    bus.$on("highlightElement");
  },
};
</script>
